import { useSWR } from '@tiger/swr';
import security from 'stores/security';
import API from 'utils/API';

export function useDistributionTaxYears() {
    return useSWR<number[]>(
        security.isIRAAccount && {
            url: API.TRADE.deposit.getWithdrawalTaxYear(),
            params: {
                customer_id: security.currentCustomerId,
                account_id: security.currentAccountId
            }
        },
        {
            immutable: true,
            dataChain: resp => resp.data
        }
    );
}
